<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.875 4.9375V8.875H14.8125C15.2773 8.875 15.6875 9.28516 15.6875 9.75C15.6875 10.2422 15.2773 10.625 14.8125 10.625H10.875V14.5625C10.875 15.0547 10.4648 15.4375 10 15.4375C9.50781 15.4375 9.125 15.0547 9.125 14.5625V10.625H5.1875C4.69531 10.625 4.3125 10.2422 4.3125 9.75C4.3125 9.28516 4.69531 8.875 5.1875 8.875H9.125V4.9375C9.125 4.47266 9.50781 4.0625 10 4.0625C10.4648 4.0625 10.875 4.47266 10.875 4.9375Z"
      fill="currentColor"
    />
  </svg>
</template>
